import { render, staticRenderFns } from "./modelt_template_config_edit.vue?vue&type=template&id=f39a84ae&scoped=true"
import script from "./modelt_template_config_edit.vue?vue&type=script&lang=js"
export * from "./modelt_template_config_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39a84ae",
  null
  
)

export default component.exports